export default __webpack_public_path__ + "static/media/lab3.99b18988.png";